import { Box, Stack } from '@mui/material'

import CattlesLogo from 'assets/CattlesLogo'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'

export const HerdAll = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_food_table || error) return null

	const milky = statistics?.herd?.milky
	const dry = statistics?.herd?.dry

	const total = milky == null || dry == null ? null : milky + dry

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<CattlesLogo color={COLORS.main} width={18} height={18} />
				</Box>
			}
			path={'/cattles'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='column' gap='4px'>
					{total === null ? (
						<TypographySecondary>Нет данных</TypographySecondary>
					) : (
						<TypographyPrimary16Bold>{total}</TypographyPrimary16Bold>
					)}
					<TypographyPrimary>Всего голов</TypographyPrimary>
				</Stack>
			</Stack>
		</BaseWidget>
	)
}
